import React from 'react'
import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { Button, Form, Modal } from '_zari/core'

import { ZariContext } from '_zari/context'
import * as TempInventarioCrud from 'services/tempInventario.service'

import { ZrSwal } from 'utils'

import FileFormGroup from './formGroups/file'

const ImportarRegistrosModal = ({ handleClose, show, tipoRegistro }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    const submitData = new FormData()
    submitData.append('file', data.file)

    ZrSwal.showAlert({
      mensaje: `Los registros se importarán bajo la sucursal ${__adminContext.nombreSede}, ¿Seguro que desea continuar?`,
      showCerrar: true,
      tipo: 'info',
      onSuccess: () => {
        TempInventarioCrud.importarRegistros(tipoRegistro, submitData)
          .then(() => {
            __zariContext.snack('success', 'Los datos se han importado correctamente.')
            handleClose()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      }
    })
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR REGISTROS</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarRegistrosModal
